import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { ClientService } from '../../../services/client.service'
import { ActivatedRoute, Router } from '@angular/router'
import { LazyLoaderService } from '../../../services/lazy-loader.service'
import { enquiriesPath, Enquiry } from '@parkupp/core'
import { addDoc, collection, serverTimestamp } from '@angular/fire/firestore'
import * as firestore from 'firebase/firestore'

@Component({
    selector: 'app-enquiry-form',
    templateUrl: './enquiry-form.component.html',
    styleUrls: ['./enquiry-form.component.scss'],
})
export class EnquiryFormComponent implements OnInit {
    formGroup: FormGroup
    formLoading = false
    formError = ''
    enquiry: Enquiry
    formComplete = false

    constructor(private fb: FormBuilder, private clientService: ClientService, private router: Router, private activatedRoute: ActivatedRoute, private lazyLoaderService: LazyLoaderService) {
        if (this.activatedRoute.snapshot.paramMap.get('status')) {
            this.formComplete = true
        }

        this.enquiry = new Enquiry()

        this.formGroup = this.fb.group({
            name: [''],
            email: [''],
            phone: [''],
            location: [''],
            bays: [''],
            detail: [''],
        })
    }

    onSubmit() {
        this.formLoading = true
        // this.formError = ''

        this.enquiry.patch(this.formGroup.value)
        this.enquiry.createdAt = serverTimestamp() as firestore.Timestamp
        console.log(this.enquiry)

        addDoc(collection(this.clientService.firestore, enquiriesPath()), this.enquiry.parse()).then((docRef) => {
            this.formLoading = false
            this.router.navigate([`/contact/complete`])
            return
        })
    }

    ngOnInit(): void {}
}
